import { render, staticRenderFns } from "./PublicProductPriceSelect.vue?vue&type=template&id=6a878be8&scoped=true&"
import script from "./PublicProductPriceSelect.vue?vue&type=script&lang=js&"
export * from "./PublicProductPriceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a878be8",
  null
  
)

export default component.exports